/**
 * Check if an element is hide to the left
 * inside of a parent that has horizontal scroll
 * @param HTMLElement currentElement
 * @returns
 */
export const isElementHideToTheLeft = currentElement =>
  currentElement.parentNode.scrollLeft + window.innerWidth < currentElement.offsetLeft + currentElement.scrollWidth;

/**
 * Check if an element is hide to the right
 * inside of a parent that has horizontal scroll
 * @param HTMLElement currentElement
 * @returns
 */
export const isElementHideToTheRight = currentElement => currentElement.offsetLeft < currentElement.parentNode.scrollLeft;

/**
 * Scroll the parent in order to show the element
 * aligned to the right
 * @param HTMLElement currentElement
 * @returns
 */
export const scrollMenuToshowElementAlignedToTheRight = currentElement =>
  (currentElement.parentNode.scrollLeft = currentElement.offsetLeft - window.innerWidth + currentElement.scrollWidth + 10);
